import { useEffect } from 'react'
import './LegacyErrorPage.css'

export function LegacyErrorPage() {
  useEffect(() => { document.title = '에러페이지' }, [])
  return <div className="fof legacy-error-page"><h1>에러페이지 404</h1><h5>일시적인 에러입니다. 다시 시도해주세요.</h5><button className="g_btn normal_size save" type="button" onClick={() => { window.location.href = '/' }}>홈으로</button>{' '}<button className="g_btn delete normal_size" type="button" onClick={() => window.history.back()}>뒤로가기</button></div>
}
